import { createSelector } from "@reduxjs/toolkit";
import { TaskRoute } from "tm-shared/types";

import { RootState } from "@/store";

const selectProgress = (s: RootState) => s.progress;
const selectTaskMarketMap = (s: RootState) => s.work.taskMarketMap;
const selectExistingTasks = (s: RootState) => s.work.tasks;

export const selectUncompletedTasks = createSelector(
    [selectProgress, selectTaskMarketMap, selectExistingTasks],
    (progress, taskMarketMap, existingTasks) => {
        const taskIds = Object.values(TaskRoute).flatMap((routeKey) =>
            Object.keys(progress[routeKey] ?? {}),
        );

        return taskIds.flatMap((taskId) => {
            const marketId = taskMarketMap[taskId];
            if (!marketId) return [];

            const task = existingTasks?.[marketId]?.[taskId];
            if (!task || task.completed) return [];

            return [{ taskId, marketId }];
        });
    },
);
